import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import React__default, { forwardRef, useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import styles from './b2d7709159f0699753f25d368041565c522bfe9b8ef419d14dff49fa68579b83.cfe-internal.js';
import '../Input/8b306eed80472bc167488d029758903f189ea21b58685c7d85ad4a1de9637088.cfe-internal.js';
import '../../icons/index.es.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import useControllableState from '../../hooks/useControllableState/fc7c2512fc1249f4837f2cb1f271d18191fa6aebd32c5f03023614c2b76711ef.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import Input from '../Input/0313aac0a73c29ca9b860be5ca5b212107cd810318bb0b89176cc766dbf84b47.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';
import SearchIcon from '../../icons/components/fd44f420e4f0cf097c788b0db805e5b1767bfe0b6caaa7e8803b476a89e57dbc.cfe-internal.js';
import CloseIcon from '../../icons/components/d75b7d62e2d618a2ae2b81c1622c1e68663cf5c48535c80292d4154d2269378b.cfe-internal.js';

var SearchInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
    value = _ref.value,
    onChange = _ref.onChange,
    onKeyDown = _ref.onKeyDown,
    placeholder = _ref.placeholder,
    ariaLabel = _ref['aria-label'],
    ariaLabelledby = _ref['aria-labelledby'],
    ariaDescribedby = _ref['aria-describedby'],
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    className = _ref.className,
    style = _ref.style,
    id = _ref.id,
    dataTestid = _ref['data-testid'];
  var _useControllableState = useControllableState(defaultValue, onChange, value),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    inputValue = _useControllableState2[0],
    setInputValue = _useControllableState2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    wasInputValueCleared = _useState2[0],
    setWasInputValueCleared = _useState2[1];
  var inputRef = useRef(null);
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var clearButtonLabel = translate('clearSearchInput');
  var isClearButtonHidden = !inputValue || isDisabled;

  // Focuses the input after the input value is cleared so that screen readers see that the input doesn't have a value
  useEffect(function () {
    if (wasInputValueCleared) {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
      setWasInputValueCleared(false);
    }
  }, [wasInputValueCleared]);
  var clearInputText = function clearInputText() {
    setInputValue('');
    setWasInputValueCleared(true);
  };
  var handleInputChange = function handleInputChange(e) {
    setInputValue(e.target.value);
  };
  var handleInputKeyDown = function handleInputKeyDown(e) {
    if (e.key === 'Escape') {
      if (inputValue) {
        e.stopPropagation(); // prevent event from closing modals or popovers
      }
      clearInputText();
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
  };
  return /*#__PURE__*/React__default.createElement("span", {
    className: classNames(styles.searchInput, className),
    style: style
  }, /*#__PURE__*/React__default.createElement(Input, {
    role: "searchbox",
    id: id,
    className: styles.searchInputInput,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : translate('searchText'),
    value: inputValue,
    onChange: handleInputChange,
    onKeyDown: handleInputKeyDown,
    disabled: isDisabled,
    onFocus: onFocus,
    onBlur: onBlur,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedby,
    "data-testid": dataTestid,
    ref: mergeRefs(inputRef, ref)
  }), /*#__PURE__*/React__default.createElement(SearchIcon, {
    className: styles.searchInputSearchIcon,
    size: "medium",
    "aria-hidden": "true"
  }), /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: styles.searchInputClearButton,
    disabled: isDisabled,
    onClick: clearInputText,
    "aria-label": clearButtonLabel,
    style: {
      opacity: isClearButtonHidden ? 0 : 1
    },
    "aria-hidden": isClearButtonHidden,
    tabIndex: isClearButtonHidden ? -1 : 0
  }, /*#__PURE__*/React__default.createElement(CloseIcon, {
    className: styles.searchInputClearButtonIcon,
    size: "small",
    "aria-hidden": "true"
  })));
});

export { SearchInput as default };
